/**
 * AI Copilot URI constants and payload builders.
 * Requests still go through this.$http.post — do not create a new axios instance.
 */
export const AI_URI = {
  allowed: '/ai/allowed',
  prepare: '/ai/prepare',
  generate: '/ai/generate',
  runDetail: '/ai/runDetail',
  approve: '/ai/approve',
  execute: '/ai/execute',
  feedback: '/ai/feedback',
  runList: '/ai/runList'
}

export const RISK_URI = {
  list: '/studentRisk/list',
  followup: '/studentRisk/followup'
}

export const TCH_RISK_URI = {
  latestBatch: '/tchRisk/latestBatch'
}

export const FORBIDDEN_AI_BODY_KEYS = [
  'adminId',
  'ownerId',
  'recordUrl',
  'calleeId',
  'callerId',
  'mobile',
  'wechatAccount',
  'payAmount'
]

export const SENSITIVE_FACT_KEYS = [
  'mobile',
  'remarkMobile',
  'wechatAccount',
  'wechatId',
  'wechatUnionId',
  'wechatOpenId',
  'wechat',
  'idcard',
  'idCard',
  'payAmount',
  'hasPayAmount',
  'recordUrl',
  'calleeId',
  'callerId',
  'password',
  'salt',
  'birthday'
]

export function newClientRequestId () {
  return 'c' + Date.now() + '-' + Math.random().toString(16).slice(2)
}

export function buildPrepareBody ({ taskType, uid, pageRoute, excludeFactKeys, subjectType }) {
  return {
    taskType: taskType,
    subjectType: subjectType || 'STUDENT',
    subjectId: uid,
    pageRoute: pageRoute,
    excludeFactKeys: excludeFactKeys || []
  }
}

export function tchRiskLevelText (level) {
  if (level === null || level === undefined || level === '') {
    return ''
  }
  var n = Number(level)
  if (n === 2) {
    return '高'
  }
  if (n === 1) {
    return '中'
  }
  if (n === 0) {
    return '低'
  }
  return ''
}

export function tchRiskLevelColor (level) {
  if (level === null || level === undefined || level === '') {
    return ''
  }
  var n = Number(level)
  if (n === 2) {
    return '#ed4014'
  }
  if (n === 1) {
    return '#ff9900'
  }
  if (n === 0) {
    return '#80848f'
  }
  return ''
}

export function normalizeTchRiskList (data) {
  if (!data) {
    return []
  }
  if (Array.isArray(data)) {
    return data
  }
  if (Array.isArray(data.data)) {
    return data.data
  }
  if (Array.isArray(data.list)) {
    return data.list
  }
  return []
}

export function buildGenerateBody (prepareLike, clientRequestId) {
  return Object.assign({}, prepareLike, { clientRequestId: clientRequestId })
}

export function stripForbiddenAiBody (body) {
  if (!body || typeof body !== 'object') {
    return body
  }
  var out = {}
  Object.keys(body).forEach(function (key) {
    if (FORBIDDEN_AI_BODY_KEYS.indexOf(key) === -1) {
      out[key] = body[key]
    }
  })
  return out
}

export function isSensitiveFactKey (key) {
  if (!key) {
    return false
  }
  var lower = String(key).toLowerCase()
  return SENSITIVE_FACT_KEYS.some(function (item) {
    return item.toLowerCase() === lower
  })
}



// WEBPACK FOOTER //
// ./src/tools/aiApi.js